import type { CategoryContent } from '../row.js';

export const PAINTERS: CategoryContent = {
  bscba: [
    [
      'Welke Renaissanceschilder staat vooral bekend om zijn gedetailleerde fresco\'s in de Brancacci-kapel?',
      [
        'Masaccio',
        'Rafaël',
        'Donatello',
        'Ghirlandaio',
      ],
      0,
      'Masaccio\'s werk in de Brancacci-kapel (1425–1428) pionierde lineair perspectief en anatomische nauwkeurigheid, wat hem tot een fundamentale figuur in de Renaissancekunst maakte.',
    ],
    [
      'Welke schildertechniek bestaat uit het aanbrengen van pigment op nat pleisterwerk, dat tijdens het drogen chemisch bindt?',
      [
        'Fresco',
        'Tempera',
        'Encaustiek',
        'Glazuren',
      ],
      0,
      'Fresco (Italiaans: "vers") is de enige schildertechniek waarbij pigment onderdeel wordt van het pleisterwerk zelf, wat het zeer duurzaam maakt maar geen fouten toelaat.',
    ],
    [
      'Welke beweging uit de late 19e eeuw gaf prioriteit aan licht, kleur en het voorbijgaande moment boven narratieve details?',
      [
        'Impressionisme',
        'Romantiek',
        'Symbolisme',
        'Barok',
      ],
      0,
      'Impressionisten als Monet en Renoir braken met de academische traditie door buiten te schilderen en vorm op te lossen in kleur- en lichteffecten.',
    ],
    [
      'Wie schilderde "De sterrenhemel"?',
      [
        'Vincent van Gogh',
        'Paul Cézanne',
        'Henri de Toulouse-Lautrec',
        'Édouard Manet',
      ],
      0,
      'Van Goghs meesterwerk uit 1889 gebruikt wervelende penseelstreken en levendige kleuren om een nachtelijke hemel boven een Frans dorp uit te beelden, wat Post-Impressionisme belichaamt.',
    ],
    [
      'Welke doorzichtige verflaag, aangebracht over droog onderwerk, voegt glans en diepte toe?',
      [
        'Glanslaag',
        'Impasto',
        'Scumble',
        'Grisaille',
      ],
      0,
      'Glazuren bestaan uit dunne, doorschijnende verflagen die onderliggende lagen zichtbaar laten worden, wat optische kleurmengeling en diepte in oude meesters creëert.',
    ],
    [
      'Wat is het voornaamste drageroppervlak voor de meeste Europese olieverfschilderijen sinds de Renaissance?',
      [
        'Canvas',
        'Houten paneel',
        'Koperen plaat',
        'Perkament',
      ],
      0,
      'Canvas werd na circa 1500 de standaard voor olieverfschilderijen, omdat het goedkoper, lichter en gemakkelijker te vervoeren en op te slaan was dan houten panelen.',
    ],
    [
      'Welke kunstbeweging verwierp het academische naturalisme en koos voor emotionele expressie en levendige, niet-natuurlijke kleuren?',
      [
        'Expressionisme',
        'Realisme',
        'Neoclassicisme',
        'Academicisme',
      ],
      0,
      'Expressionisten (vroege 20e eeuw) als Kirchner en Kandinsky gaven prioriteit aan subjectief gevoel en vervormde vorm om psychologische toestanden uit te drukken.',
    ],
    [
      'Wie schilderde "De geboorte van Venus"?',
      [
        'Sandro Botticelli',
        'Leonardo da Vinci',
        'Michelangelo',
        'Brunelleschi',
      ],
      0,
      'Botticelli\'s meesterwerk uit circa 1485, in de Uffizi-galerij, belichaamt Renaissanceschoonheid met vloeiende lijnen en mythologische onderwerpen.',
    ],
    [
      'Welke vroege temperatechniek gebruikte eigeel als bindmiddel en produceerde matte afwerkingen?',
      [
        'Eitemperatechniek',
        'Olie-alkyd',
        'Acryl',
        'Fresco secco',
      ],
      0,
      'Eitemperatechniek was vóór de Renaissance het dominante medium; pigmenten gemengd met eigeel droogden snel en waren moeilijker te mengen dan olieverf.',
    ],
    [
      'Welke kunstbeweging uit de 17e eeuw dramatiseerde licht en schaduw voor emotionele intensiteit?',
      [
        'Barok',
        'Rococo',
        'Manierisme',
        'Hoge Renaissance',
      ],
      0,
      'Barokkunstenaars als Caravaggio gebruikten chiaroscuro (sterke licht-donkercontrasten) en dynamische compositie om theatrale, emotioneel geladen scènes te creëren.',
    ],
    [
      'Wat is de dikke, zichtbaar getextureerde verfaanbreng die fysieke dimensie op canvas creëert?',
      [
        'Impasto',
        'Sfumato',
        'Chiaroscuro',
        'Pentimento',
      ],
      0,
      'Impasto is zichtbaar penseelwerk of paletmesaanbreng waarbij verf dik op het oppervlak ligt, licht vangt en tactiele textuur creëert.',
    ],
    [
      'Wie is de Nederlandse Post-Impressionist vooral beroemd om zijn zonnebloem- en graanveldschilderijen?',
      [
        'Vincent van Gogh',
        'Paul Gauguin',
        'Georges Seurat',
        'Edvard Munch',
      ],
      0,
      'Van Gogh creëerde zijn zonnebloemenreeks in Arles, Frankrijk (1888–1889); de schilderijen gebruiken symbolisme en expressieve kleur om schoonheid uit te drukken.',
    ],
    [
      'Welk compositieprincipe plaatst het onderwerp buiten het centrum op ongeveer een derde van het beeld?',
      [
        'Derdelingenregel',
        'Gulden snede',
        'Lineair perspectief',
        'Bilaterale symmetrie',
      ],
      0,
      'De derdelingenregel, afgeleid van Renaissanceproporties, creëert visueel evenwicht door brandpunten weg van het centrum te plaatsen.',
    ],
    [
      'Welke Italiaanse Renaissancemeester schilderde "De School van Athene" in het Vaticaan?',
      [
        'Rafaël',
        'Michelangelo',
        'Leonardo da Vinci',
        'Botticelli',
      ],
      0,
      'Rafaëls monumentale fresco (1509–1511) in de Vaticaanse Stanza della Segnatura stelt klassieke filosofen voor in een harmonieuze Renaissancecompositie.',
    ],
    [
      'Welke term beschrijft de geleidelijke, bijna onzichtbare menging van tonen voor zachte overgangen?',
      [
        'Sfumato',
        'Chiaroscuro',
        'Tenebrisme',
        'Pointillisme',
      ],
      0,
      'Sfumato, gepioneerd door Leonardo da Vinci, vervaagt randen en tonen zo subtiel dat omlijningen lijken op te lossen, wat atmosferisch perspectief creëert.',
    ],
  ],
  msc: [
    [
      'In vroeg Nederlands schilderwerk stond welke revolutionaire techniek schilders toe om doorschijnende olieverglazuren met ongekende helderheid te stapelen?',
      [
        'Opeenvolgende dunne olieglazuren',
        'De Venetiaanse methode van tempera onder olie',
        'Het gebruik van walnootolie in plaats van lijnzaadolie',
        'Het voormengen van pigmenten met gemalen glas',
      ],
      0,
      'Jan van Eyck en zijn tijdgenoten perfectioneerden de olieverglazuurtechniek, wat minuscuul detail en juweelachtige kleur toestond die tempera niet kon evenaren.',
    ],
    [
      'Wat vereist "sfumato" technisch dat "chiaroscuro" niet vereist?',
      [
        'Onwaarneembare toonovergangen',
        'Dramatisch contrast tussen licht- en schaduwzones',
        'Een koele tint in schaduw en warm in licht',
        'Meerdere voorbereidende ondertekeningen',
      ],
      0,
      'Sfumato vereist optische menging waarbij tonen zo soepel overgaan dat randen verdwijnen; chiaroscuro tolereert zichtbare schaduwgrenzen, wat sfumato technisch veeleisender maakt.',
    ],
    [
      'Welke Italiaanse meesters werkplaats perfectioneerde de techniek waarbij leerlingen composities aanlegden terwijl de meester gezichten verfijnde?',
      [
        'Rafaël',
        'Michelangelo',
        'Caravaggio',
        'Parmigianino',
      ],
      0,
      'Rafaëls werkplaats werkte volgens arbeidsverdeling; zijn leerlingen (Giulio Romano, Giovanni da Udine) voerden voorbereiding uit, wat commissies versnelde.',
    ],
    [
      'Wat is de standaard voorbereidende laag voor olieverfschildering op canvas die de weving afdicht en een stabiele ondergrond vormt?',
      [
        'Gesso',
        'Vernis',
        'Alleen lijnzaadolie',
        'Wit loodverf',
      ],
      0,
      'Gesso, een traditionele grond van calciumsulfaat en dierlijke lijm, creëert een niet-absorberend oppervlak dat olieabsorptie in de canvasvezels voorkomt en zo een goede verfafzetting waarborgt.',
    ],
    [
      'In Renaissanceperspectiefleer, wat is het verdwijnpunt waar orthogonale lijnen in lineair perspectief convergeren?',
      [
        'Waar parallelle lijnen samenkomen op de horizon',
        'Het verst zichtbare object in het schilderij',
        'Het helderste gebied van de compositie',
        'Het precieze midden van het canvas',
      ],
      0,
      'Het verdwijnpunt, wiskundig bepaald door Brunelleschi en getheoretiseerd door Alberti, creëert de illusie van driedimensionale ruimte op een vlak oppervlak.',
    ],
    [
      'Welke Venetiaanse meester uit de 16e eeuw pionierde het creëren van vorm vooral door kleur in plaats van lijn?',
      [
        'Titiaan',
        'Tintoretto',
        'Veronese',
        'Paolo Uccello',
      ],
      0,
      'Titiaan ontwikkelde de "malerische" benadering, waarbij hij kleurharmonieën en penseelwerk liet prevaleren boven precies tekenwerk. Dit beïnvloedde alle latere Europese tradities.',
    ],
    [
      'Waar verwijst "pentimento" naar in bewaarings- en kunstgeschiedenis?',
      [
        'Een spoor van een eerdere compositie',
        'Een scheur in oude verf veroorzaakt door temperatuursverandering',
        'De handtekening of monogram verborgen in een schilderij',
        'Het verwijderen van vernis tijdens restauratie',
      ],
      0,
      'Pentimento (Italiaans: "berouw") toont de tweede gedachten van een kunstenaar; röntgenfotografie onthult vaak eerdere compositionele versies onder de uiteindelijke verflagen.',
    ],
    [
      'Welke Noord-Renaissance schilder ontwikkelde de techniek van witte lijnranden rond figuren om omtrek te versterken?',
      [
        'Albrecht Dürer',
        'Lucas Cranach',
        'Matthias Grünewald',
        'Hans Burgkmair',
      ],
      0,
      'Dürer paste deze techniek uit de Vlaamse praktijk aan, waarbij fijne witte of heldere omlijningen randen scherp definiëren, karakteristiek voor Noord-Renaissance panelen.',
    ],
    [
      'Wat is de dunne onderschilderingslaag in olieverfschildering, vaak in monochroom, die tonale waarden en vorm bepaalt?',
      [
        'Onderverf',
        'Imprimatura',
        'Glanslaag',
        'Waterkleur',
      ],
      0,
      'Onderschildering brengt waarden en compositie in kaart voordat er geglazuurd wordt; sinopia (voor fresco) is de voorbereidende tekening op de arriccio die het frescowerk leidt.',
    ],
    [
      'Welke Barokschilder pionierde "tenebrisme," een extreme vorm van chiaroscuro met vrijwel hele scènes in duisternis?',
      [
        'Caravaggio',
        'Artemisia Gentileschi',
        'Rembrandt',
        'Peter Paul Rubens',
      ],
      0,
      'Caravaggio\'s tenebrisme isoleert verlichte figuren tegen bijna totale duisternis, wat psychologisch drama en theatrale lichtleiding creëert.',
    ],
    [
      'Wat is "distemper"-schildering, een techniek verschillend van tempera, en waar werd het historisch vooral gebruikt?',
      [
        'Waterbasis verf op lijmbasis',
        'Een techniek met ei en olie gecombineerd',
        'Een fresco-variant met kalk en zand',
        'Een encaustiek-tempera hybride uit 15e-eeuws Italië',
      ],
      0,
      'Distemper (lijmbasis) werd gewaardeerd voor toneeldecoratief werk en decoratieve muurschilderingen waar duurzaamheid minder kritisch was; het blijft vergankelijk.',
    ],
    [
      'In Hoge Renaissance-compositie, wat is het principe van "figura serpentinata" of de serpentijnvormige figuur?',
      [
        'Een verlengde, zwiepende figuurhouding',
        'Een geometrische regeling van meerdere figuren in diagonale lijnen',
        'De plaatsing van figuren in strikte bilaterale symmetrie',
        'Het gebruik van groene en blauwe tonen voor visuele serpentijnpatronen',
      ],
      0,
      'Serpentijnfiguren, exemplarisch voor het Manierisme, gebruiken zwierige contrapposto die het lichaam verlengt en krult voor elegante, dynamische composities.',
    ],
    [
      'Wat is de voornaamste reden waarom Renaissance- en Barokschilders lijnzaadolie boven andere bindmiddelen verkozen?',
      [
        'Het droogt door oxidatie tot een harde, duurzame laag',
        'Het droogt sneller dan walnootolie',
        'Het voorkomt scheurvorming beter dan andere oliën',
        'Het produceert een glanzend oppervlak zonder extra vernis',
      ],
      0,
      'Lijnzaadolie oxideert (polymeriseert) met gecontroleerde snelheid, wat een sterke, flexibele film creëert die niet significant verdonkert; andere oliën werden vermeden vanwege mindere duurzaamheid.',
    ],
    [
      'Welk iconografisch symbool verschijnt herhaaldelijk in Noord-Renaissance schilderwerk om goddelijke aanwezigheid te vertegenwoordigen?',
      [
        'Gouden achtergrond',
        'De afwezigheid van schaduwen',
        'Exclusief rood pigment',
        'Waterweerspiegelingen',
      ],
      0,
      'Goudfolie- en goudverfachtergronden, een middeleeuwse erfenis in de Noord-Renaissance, betekenden heilige ruimte en het onwezenlijke goddelijke, onderscheiden van aards naturalisme.',
    ],
    [
      'Waar slaat "intonaco" op in fresco-techniek en waarom is de kwaliteit ervan kritiek?',
      [
        'De laatste natte pleisterlaag',
        'De voorbereidende houtskool onderteekening',
        'De droge zand- en kalkmortelgrondlaag',
        'Het kleurpigment gemengd in pleisterwerk',
      ],
      0,
      'Intonaco moet gelijkmatig gehydrateerd en dun genoeg zijn voor chemische binding; mindere kwaliteit voorkomt juiste pigmentafzetting, wat ertoe leidt dat het fresco vervalt en afschilfert.',
    ],
  ],
  phd: [
    [
      'Hoe beïnvloedde de overgang van tempera naar olieverf in Laat-Gotisch en Vroeg-Nederlands schilderwerk het sculpturale illusionisme?',
      [
        'Trage droging en transparantie gaven gelaagde optische diepte',
        'Tempera droogde te snel, wat gedetailleerde onderschildering voor anatomie voorkwam',
        'Oliepigmenten waren chemisch simpelweg levendiger dan temperapigmenten',
        'Olie stelde kunstenaars in staat op grotere canvasdragers te schilderen dan tempera toeliet',
      ],
      0,
      'Vlaamse meesters als Rogier van der Weyden gebruikten olieverglazuren om vorm subtiel door kleur zonder lijn te modelleren, waardoor een sculpturaal driedimensionaal effect ontstond.',
    ],
    [
      'Wat onderscheidt Titiaans latere "gebroken kleur"-techniek van vroegere Venetiaanse kleurfocus qua penseelwerk en optische mengeling?',
      [
        'Zichtbare streken die optisch mengen in het oog',
        'Vroeg-Titiaan mengde alle kleuren volledig op de palet',
        'Gebroken kleur vereist zichtbare monochrome onderschildering',
        'De techniek is louter pigmentkeuze, geen toepassingsmethode',
      ],
      0,
      'Titiaans latere werken brengen verf losjes aan in parallelle streken waar de kleuren in het oog van de beschouwer mengen; deze optische benadering beïnvloedde coloristen eeuwen later.',
    ],
    [
      'Waarom werd loodwit universeel verkozen boven ander wit pigment in olieverfschilderijen van de oude meesters, ondanks de bekende toxiciteit?',
      [
        'Het oxideert snel en droogt zonder te vergelen',
        'Het reflecteert meer licht dan ander pigment',
        'Het was het enige beschikbare witte pigment in Renaissance Europa',
        'Het voorkomt scheuren in het schilderij door tijd',
      ],
      0,
      'Loodwit oxideerde snel, wat de verffilmvorming versnelde en de vergeling voorkwam die bij ander wit pigment optrad; de toxiciteit werd aanvaardbaar geacht gezien de superieure prestaties.',
    ],
    [
      'In Hoge Renaissance narratieve compositie, welk structuurprincipe gebruikte Rafaël om meerdere brandpunten te verenigen zonder hiërarchische overheersing?',
      [
        'Driehoekige figuurgroepering met gestaffelde diepten',
        'Centraal verdwijnpunt waarvan alle elementen uitstralen',
        'Volledige symmetrie rond verticale as',
        'Diagonale horizonlijnen die de aandacht naar linksboven forceren',
      ],
      0,
      'Rafaëls driehoekige figuurschikkingen (zichtbaar in de Vaticaanse fresco\'s) leiden het oog langs onderling verbonden vlakken; deze geometrische harmonie werd de canonieke Renaissance-compositie.',
    ],
    [
      'Wat is de specifieke rol van "arriccio" en "sinopia" lagen in echte frescotechniek en hoe beïnvloeden zij de artistieke werkflow?',
      [
        'Arriccio ontvangt de sinopia-ondertekening',
        'Zij zijn dezelfde laag met verschillende namen',
        'Slechts één wordt gebruikt in Klassiek Romeins fresco',
        'Zij worden aangebracht nadat de geverfde laag droogt',
      ],
      0,
      'Sinopia op de arriccio stelt de kunstenaar in staat de compositie gedetailleerd te plannen. Zodra de intonaco is aangebracht, zijn veranderingen onmogelijk, wat sinopia tot een essentiële planningsfase maakt.',
    ],
    [
      'Hoe gebruikten Noord-Renaissance schilders kleurgradiëring om atmosferisch perspectief te bereiken, in tegenstelling tot Italiaans lineair perspectief?',
      [
        'Blauwgrijze tint in de verte',
        'Zij gebruikten dezelfde technieken als Italiaanse schilders',
        'Noord-schilders verworpen perspectief totaal',
        'Alleen Italiaanse schilders begrepen kleurperspectief',
      ],
      0,
      'De Noord-Renaissance gebruikte een verschuiving naar koelere tonen en lagere verzadiging voor de achtergrond om optisch perspectief te bereiken; dit vulde het lineaire perspectief aan in plaats van het te vervangen.',
    ],
    [
      'Wat is "fustaanbekleding" in historische verfterminologie, en welk risico op pigmentinstabiliteit hield dit in?',
      [
        'Kleurstoffen die onvoorspelbaar vervagen',
        'Een technische term voor impasto aanbreng',
        'Een specifiek bindmiddel van katoen',
        'Een archaïsche term voor glazuurtechniek',
      ],
      0,
      'Fustaanpigmenten (organische lacken als meekrap) zijn vergankelijk; handelaren verkochten deze soms als permanente pigmenten, wat kleurverlies en tintverschuivingen in oude schilderijen veroorzaakte.',
    ],
    [
      'Welke specifieke innovaties in studiolichting en verfformulering vereiste Caravaggio\'s tenebrisme-techniek?',
      [
        'Snel-droogende, dekkende verf met hoge kleurkracht',
        'Hij vond een specifiek pigment voor tenebrisme uit',
        'De techniek vereiste alleen donkerder pigmenten, geen speciale formulering',
        'Het was louter onderwerpkwestie, geen technische aanpassing',
      ],
      0,
      'Caravaggio\'s hoog-contrast stijl vereiste zelfverzekerde waardeplaatsing van start; hij gebruikte loodwit rijkelijk en werkte onder gerichte atelierverlichting.',
    ],
    [
      'Wat onthult röntgenfotografie over Rembrandts correctiepatronen dat wijst op een doelbewuste revisieaanpak, anders dan bij andere Barokschilders?',
      [
        'Uitgebreide, methodische pentimenti',
        'Rembrandt maakte nooit correcties',
        'Zijn pentimenti zijn willekeurig en onvoorzichtig',
        'Röntgenfotografie kan Rembrandts technieken niet onthullen',
      ],
      0,
      'Röntgenstralen tonen Rembrandts systematische herpositionering van figuren en herkalibrering van gebaren; dit suggereert een generatief proces dat de voorkeur gaf aan spontane revisie boven vaste voorbereiding.',
    ],
    [
      'Verklaar, in de Barokiconografie, de symbolische functie van specifieke kleurreeksen (bijv. rood-blauw-goud) in Mariabeelden.',
      [
        'Passie (rood), deugd (blauw), majesteit (goud)',
        'Kleuren waren willekeurig zonder symbolische betekenis',
        'Alleen blauw had religieuze betekenis',
        'Kleursymboliek veranderde elke eeuw zonder consistentie',
      ],
      0,
      'Mariale kleursymboliek werd gecodificeerd in middeleeuwse en Renaissance-iconografische teksten; rood-blauw-goud-combinaties verschenen doelbewust om theologische betekenis visueel vast te leggen.',
    ],
    [
      'Wat onthult conserveringsbewijs (craquelurepatronen, verflaagsamenstelling) over het verschil tussen authentieke Oude Meesters en 18e-eeuwse kopieën of aanpassingen?',
      [
        'Leeftijdspecifieke craquelure die past bij de periode',
        'Alle oude schilderijen hebben identieke craquelure',
        'Craquelure is louter decoratief en betekenisloos',
        'Bewaartechnieken kunnen vervalsingen niet detecteren',
      ],
      0,
      'Leeftijdspecifieke craquelure, tijdlijnen van pigmentbeschikbaarheid en bindmiddel-oxidatiepatronen bieden chronologische vingerafdrukken; anachronismen ontmaskeren kopieën of uitgebreid later herzieningswerk.',
    ],
    [
      'Hoe verschilde de Renaissance-toepassing van Vitruviaanse verhoudingen van middeleeuwse symbolische geometrische schema\'s?',
      [
        'Vitruviaanse verhoudingen kwamen voort uit de anatomie, niet uit symbolische meetkunde',
        'Beiden zijn identiek',
        'Vitruviaanse verhoudingen werden in Renaissance uitgevonden zonder klassieke bron',
        'Middeleeuwse schilders gebruikten nooit geometrische schema\'s',
      ],
      0,
      'Brunelleschi en Alberti pasten Vitruvius\' op het menselijk lichaam gebaseerde verhoudingen toe (bijvoorbeeld de verhouding 1:2:3). Deze vervingen de middeleeuwse symbolische meetkunde door ratio\'s die gebaseerd waren op waargenomen anatomische harmonie.',
    ],
    [
      'In de restauratie van een Barok canvas, welk bewijs zou onderscheid maken tussen originele verf, vroege vernisvergelingen en latere hertekeningen?',
      [
        'IR en UV tonen vernisouderdom en hertekening',
        'Er is geen manier om deze te onderscheiden',
        'Alle oude schilderijen zien er identiek uit onder beeldvorming',
        'Alleen chemische analyse werkt, beeldvorming helpt niet',
      ],
      0,
      'IR toont de rijpheid van de originele verf, UV-fluorescentie markeert moderne hertekenmaterialen, stratigrafische analyse onthult vernislagen; samen brengen deze diagnostische methoden de restauratiegeschiedenis in kaart.',
    ],
    [
      'Wat beschrijft de dichotomie "Venetiaans colorisme" tegenover "Florentijnse tekening" in Renaissance kunstkritiek in termen van onderliggende artistieke filosofie?',
      [
        'Florentijnse lijnvorm versus Venetiaanse kleurharmonie',
        'Venetiaanse schilders waren slechter in tekenen dan Florentijnse schilders',
        'Het is louter geografische gemak zonder filosofische grondslag',
        'Beide scholen gebruikten identieke methoden',
      ],
      0,
      'De dichotomie weerspiegelt de intellect-versus-zintuigpolariteit van het Renaissance-humanisme: Florence benadrukte rationeel ontwerp (disegno), Venetië vierde optische kleur en visueel genoegen (colorito).',
    ],
    [
      'Welk technisch doel dienden "waterverf"-lagen in aquarel- en gouachevoorbereiding, en waarin onderscheidde dit hen van tempera- en olietechnieken?',
      [
        'Waterverflagen vereisen absorberend papier, geen gesso',
        'Waterverflagen zijn identiek aan glazuren',
        'Aquarel en gouache zijn oliën',
        'Waterverftechniek vereist loodwit als olieverfschildering',
      ],
      0,
      'Papierabsorptie stelt transparante waterverflagen toe snel te drogen en optisch te mengen; gesso-gebonden panelen van tempera en olie vereisen mechanische mengling, niet optische lagen.',
    ],
  ],
  professor: [
    [
      'Hoe bepaalde de moleculaire polymerisatiekinetiek van verschillende bindmiddelen (walnoot-, lijnzaad- en saffraanolie) de haalbaarheid van specifieke Venetiaanse coloristtechnieken?',
      [
        'Lijnzaads trage oxidatie maakte gelaagde natte menging mogelijk',
        'Alle oliën polymeriseren identiek',
        'Pigmentkleur bepaalt bindmiddelgedrag',
        'Oliekeuse was louter esthetisch zonder technische gevolg',
      ],
      0,
      'Walnootolies snelle polymerisatie en saffraanolies slechte droging maakten ze ongeschikt voor optische natte-in-natmenging; lijnzaadolies beheersbare kinetiek ondersteunde Venetiaanse gebroken-kleureffecten die met andere media onmogelijk waren.',
    ],
    [
      'Hoe bepaalde de afhankelijkheid van fresco\'s van kalkkarbonatisering als bindmechanisme de verwerping van de techniek tijdens de Noord-Renaissance?',
      [
        'Fresco\'s onomkeerbare binding dreef schilders naar olie',
        'Fresco is intrinsiek duurzamer dan olie',
        'Noord-schilders kozen gewoon olie om esthetische redenen',
        'Frescokarbonatisering is ogenblikkelijk en omkeerbaar',
      ],
      0,
      'Zodra de intonaco was aangebracht, waren pentimenti onmogelijk; de herzienbaarheid van olieverf (het drogen liet schrapen en overschilderen toe) sloot aan bij de Renaissance-nadruk op intellectuele verfijning en werkplaatsarbeidsverdeling.',
    ],
    [
      'In hedendaagse bewaringswetenschappen, verklaar het epistemologische probleem van schilderijtoewijzing via pigmentanalyse wanneer post-productieveranderingsgeschiedenis onbekend is.',
      [
        'Pigmentanalyse bewijst geen authenticiteit alleen',
        'Pigmentanalyse bewijst definitief autheurschap',
        'Moderne pigmenten bevinden zich nooit in oude schilderijen',
        'Gewijzigde schilderijen tonen altijd zichtbaar bewijs',
      ],
      0,
      'Pigmentanalyse biedt bewijsmateriaal (anachronistische lapis lazuli suggereert 20e-eeuwse hertekening) maar kan op zichzelf geen authenticiteit bewijzen; fragmentarische restauratiedocumentatie verergert de epistemologische onzekerheid.',
    ],
    [
      'Hoe vormden Caravaggio\'s technische keuzes — hoge loodwitopaciteit, snel-instellende formulering, uitvoering in één zitting — zijn benadering van vormmodellering?',
      [
        'Hoog loodwit maakte gedurfde modellering mogelijk',
        'Caravaggio gebruikte standaard Renaissance-technieken',
        'Technische keuzes hadden geen relatie met zijn esthetiek',
        'Caravaggio gebruikte altijd traag-droogende oliën',
      ],
      0,
      'Caravaggio\'s gedocumenteerde snelle uitvoering (vaak in één zitting) vereiste hoog-opaciteit, snel-droogende verf; deze technische beperking dwong directe, emotioneel onmiddellijke licht-schaduwmodellering zonder verfijningsglazen af.',
    ],
    [
      'Wat onthullen recente neutronactiveringsanalyses van Rembrandts latere werken over de herkomst van de zeldzame-aardelementenrijke okers die hij gebruikte, en het verband met zijn stilistische evolutie?',
      [
        'Sporen van lanthanide wijzen op fijnere, later geïmporteerde okers',
        'Neutronanalyse kan sporelementen niet detecteren',
        'Rembrandts pigmentbronnen veranderden nooit',
        'Aardelementensamenstelling is irrelevant voor kleurverschijning',
      ],
      0,
      'Neutronactivering detecteerde verschoven profielen van zeldzame aarde-elementen in Rembrandts latere werken; dit komt overeen met de gedocumenteerde toename van de import van premium okers naar Amsterdam en ondersteunt zo de stilistische datering en herkomsthypothesen.',
    ],
    [
      'Kritiseer de interpretatieve grenzen van Panofsky\'s drieledige iconografische methodologie, toegepast op 15e-eeuws Nederlands schilderwerk, in het licht van opkomend bewijs van werkplaatsspecifieke symbolische codes.',
      [
        'Gildes hadden codes die Panofsky miste',
        'Panofsky\'s methode is universeel toepasselijk',
        'Werkplaatsen ontwikkelden nooit unieke symbolische codes',
        'Iconografie is irrelevant voor schilderijnanalyse',
      ],
      0,
      'Gildespecifieke heraldiek en symbolische voorkeuren van opdrachtgeversfamilies creëerden gelokaliseerde iconografische "dialecten"; Panofsky\'s gegeneraliseerde lezing mist deze doelbewuste, ondocumenteerde betekenissen op werkplaatsniveau.',
    ],
    [
      'Hoe visualiseerden laat-18e-eeuwse landschapschilders zoals Turner en Friedrich het Kantiaanse concept van het sublieme?',
      [
        'Turner en Friedrich visualiseerden Kants sublieme',
        'Kants esthetica heeft geen verbinding met schildering',
        'Het sublieme in kunst voorafgaat Kant',
        'Landschapschilders engageerden zich nooit met filosofie',
      ],
      0,
      'De composities van Turner en Friedrich belichamen doelbewust het Kantiaanse subliem: overweldigende schaal, vormeloze grootsheid en menselijke onbeduidendheid visualiseren Kants fenomenologische beschrijving van het wiskundig-dynamisch subliem.',
    ],
    [
      'In de historiografie van kunsthistorische methodologie, verklaar hoe formalistische abstractie van iconografie (Fry, Greenberg) de interpretatie van abstracte en niet-representationele werken paradoxaal genoeg zowel mogelijk maakte als beperkte.',
      [
        'Formalisme sloot historische context uit',
        'Formalisme en abstractie zijn ongerelateerd',
        'Formalisme maakte alle historische interpretaties gelijk mogelijk',
        'Abstracte schilderij vereiste geen kritische methodologie',
      ],
      0,
      'Formalisme bevrijdde abstracte kunst van iconografische decodering (bevrijdend), maar sloot dogmatisch historische, biografische en materiële contexten uit (beperkend); deze methodische asymmetrie vormt nog steeds de hedendaagse abstractiekritiek.',
    ],
    [
      'Wat onthult röntgenstraldiffractie-kristallografie van middeleeuwse vergulde oppervlakken over regionale onderscheidingen in goudslaan en bladdikte wat traditionele kunstgeschiedenis niet kan benaderen?',
      [
        'Italiaans goud is grover dan Vlaams',
        'Al middeleeuws goudblad is identiek',
        'Röntgenstraldiffractie kan goudkenmerken niet meten',
        'Goudslagtechniek was nooit regionaal onderscheiden',
      ],
      0,
      'XRD toont aan dat Italiaans goud een grovere kristallografie vertoont (dikker geslagen, minder verfijnd), terwijl Vlaams goud fijner is (arbeidsintensiever); deze technische handtekeningen weerspiegelen werkplaatsmiddelen en toegang tot handelsnetwerken.',
    ],
    [
      'Welke combinatie van factoren maakte de wetenschappelijke hertoewijzing van werken aan Artemisia Gentileschi mogelijk?',
      [
        'Archieven verhulden haar; studie herstelde haar werk',
        'Gentileschi\'s werk werd altijd correct toegerekend',
        'Geslacht beïnvloedt nooit kunsthistorische toewijzing',
        'Archiefbewijzen zijn irrelevant voor toewijzing',
      ],
      0,
      'Gentileschi\'s herstel hing af van archiefonderzoek (genegeerde commissiedocumenten), formele analyse (haar kenmerkende chiaroscuro en figurale energie) en het integreren van feministische historiografie om mistoeschrijving recht te zetten.',
    ],
    [
      'Wat was de betekenis van de "tempera-olie-emulsie"-praktijk als overgangstechnologie in het 15e-eeuwse Vlaamse schilderwerk?',
      [
        'Hybrides mengden de voordelen van elk medium',
        'Tempera en olie werden nooit gemengd',
        'Emulsietechniek werd in 19e eeuw uitgevonden',
        'Mediahybriditeit heeft geen technische betekenis',
      ],
      0,
      'Nederlandse schilders mengden experimenteel tempera en olie, waarbij ze de voordelen van elk medium benutten (snel drogende tempera-onderschildering, olieglazuurverfijning); technologisch pragmatisme ging voor op ideologische zuiverheid.',
    ],
    [
      'In de hedendaagse conserveringsethiek, waarom geven restauratoren doorgaans de voorkeur aan herroepbare retouches boven volledige esthetische reconstructie bij significant verfverlies?',
      [
        'Herroepbaarheid houdt toekomstige opties open',
        'Herroepbaarheid is altijd ethisch superieur',
        'Esthetische voltooiing is altijd juist',
        'Conserveringsethiek is irrelevant voor schilderijrestauratie',
      ],
      0,
      'Herroepbare retouches laten toekomstig onderzoek en herbehandeling toe, maar aanvaarden esthetische onvolkomenheid; volledige reconstructie riskeert het verhullen van bewijsmateriaal en presenteert een eigentijdse keuze als historisch feit.',
    ],
    [
      'Hoe beïnvloedt het optische fenomeen "halatie" (licht dat door transparante verflagen gaat en terugkaatst) de fenomenologische ervaring van geglazuurde oppervlakken van oude meesters, in de context van galerieverlichting?',
      [
        'Lichtverstrooiing creëert een hoekafhankelijke gloed',
        'Halatie is een fotografisch artefact irrelevant voor schildering',
        'Geglazuurde oppervlakken zijn optisch statisch',
        'Galerielichting heeft geen effect op waarneming',
      ],
      0,
      'Halatie produceert de optische "gloed" die waarnemers bij Oude Meesters rapporteren; licht dringt de transparante glazuren binnen, wordt er intern in gereflecteerd en treedt er onder een andere hoek weer uit. Dit hoekafhankelijke effect verklaart waarom reproducties de ervaren luminositeit niet overbrengen.',
    ],
    [
      'Bekritiseer hoe de postkoloniale kunstgeschiedenis het "Oriëntale invloeds"-verhaal in de Renaissance-schilderkunst heeft herzien, door diffusionistische kaders te verwerpen die Europa als passieve ontvanger positioneerden.',
      [
        'Handelsuitwisseling was onderhandeld, geen eenrichting',
        'Renaissanceschilders kopieerden Oriëntale kunst passief',
        'Handel beïnvloedde de Europese schildertechniek niet',
        'Postkoloniale kritiek is irrelevant voor de schilderkunstgeschiedenis',
      ],
      0,
      'Postkoloniaal onderzoek toont dat de herkomst van lapis lazuli, Islamitisch papiergebruik en glazuurtechnieken het resultaat waren van onderhandelde uitwisselingen, niet van passieve ontlening; Renaissance-appropriatie impliceert strategische transformatie, niet eenvoudige navolging.',
    ],
    [
      'In recent onderzoek naar schilders\' optische gereedschappen (camera obscura, prisma\'s, spiegels), verklaar het epistemologische probleem: optische verificatie (mechanische reproductie) versus doelbewuste artistieke interpretatie.',
      [
        'Optische hulpmiddelen tonen technisch vermogen, geen creatieve intentie',
        'Optische gereedschappen bewijzen schilderijen zijn mechanische reproducties',
        'Kunstenaars gebruikten nooit optische toestellen',
        'Optische hulpmiddelen elimineren artistieke interpretatie totaal',
      ],
      0,
      'Het gebruik van optisch gereedschap (technisch verifieerbaar) impliceert niet het elimineren van artistieke autonomie; schilders selecteerden, vervormden en herstelden optisch afgeleide afbeeldingen. De aanwezigheid van gereedschap ≠ passiviteit van de kunstenaar.',
    ],
  ],
};
